import React, { useEffect } from "react";
import { Outlet, ScrollRestoration, useLocation } from "react-router-dom";
import HeaderCst from "@components/HeaderCst";
import FooterCst from "@components/FooterCst";
import { LayoutContainer, Main } from "./LayoutHome.styles";
import ChatAgent from "@components/ChatAgent";

const SIDEBAR_LAYOUT_PATTERN = /^\/(?:v2\/)?corporate\/[^/]+\/detail(?:\/|$)/;

const LayoutHome: React.FC = () => {
  const location = useLocation();
  const hasSidebarLayout = SIDEBAR_LAYOUT_PATTERN.test(location.pathname);

  useEffect(() => {
    document.documentElement.style.setProperty("--app-header-height", "90px");
  }, []);

  return (
    <LayoutContainer>
      <HeaderCst />
      <ChatAgent />
      <Main className={hasSidebarLayout ? "v2" : "no-navigation"}>
        <Outlet />
        <ScrollRestoration />
      </Main>
      {!hasSidebarLayout && <FooterCst />}
    </LayoutContainer>
  );
};

export default LayoutHome;
